import { useState } from 'react'
import { generatePath, Link, useRouteMatch } from 'react-router-dom'
import cx from 'classnames'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { ReactComponent as ContextualIcon } from 'common/components/contextual/icon.svg'
import { ReactComponent as OptimiseIcon } from 'common/components/optimise/icon.svg'
import { useAppSelector } from 'common/hooks/redux'
import { MenuHide, MenuShow } from 'common/icons'

type Props = {
  optimisePath: string
  personalisePath: string
}

const MetabaseNavPanel = ({ optimisePath, personalisePath }: Props) => {
  const [isCollapsed, setIsCollapsed] = useState(false)
  const accountId = useAppSelector((state) => state.authStates.accountId)
  const { enableMetabaseContextual } = useFlags()
  const match = useRouteMatch([optimisePath, personalisePath])

  const navItems = [
    { label: 'Optimise', path: optimisePath, Icon: OptimiseIcon },
    ...(enableMetabaseContextual
      ? [{ label: 'Contextual', path: personalisePath, Icon: ContextualIcon }]
      : []),
  ]

  return (
    <div
      className={cx(
        'flex flex-col h-full bg-gold-100 transition-all shrink-0',
        {
          'w-12 items-center p-2': isCollapsed,
          'w-60 p-4': !isCollapsed,
        }
      )}
    >
      <div
        className={cx('flex mb-4', {
          'justify-center': isCollapsed,
          'items-center justify-between': !isCollapsed,
        })}
      >
        {!isCollapsed && (
          <span className="uppercase font-medium text-sm">Campaign Types</span>
        )}
        <button onClick={() => setIsCollapsed((c) => !c)}>
          {isCollapsed ? <MenuShow size={4} /> : <MenuHide size={4} />}
        </button>
      </div>

      <div className="flex flex-col gap-2">
        {navItems.map(({ label, path, Icon }) => {
          const isActive = match?.path === path
          return (
            <Link key={path} to={generatePath(path, { accountId })}>
              <div
                className={cx(
                  'flex items-center gap-2 px-2 py-3 rounded-sm cursor-pointer',
                  {
                    'bg-yellow-200 border-l-2 border-black': isActive,
                    'bg-gold-40 hover:bg-gold-300': !isActive,
                    'justify-center': isCollapsed,
                  }
                )}
              >
                <Icon className="w-5 h-5 shrink-0" />
                {!isCollapsed && (
                  <span className="uppercase font-medium">{label}</span>
                )}
              </div>
            </Link>
          )
        })}
      </div>
    </div>
  )
}

export default MetabaseNavPanel
